import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../UI';

interface PropTypes {
  onClick: (text?: string) => void;
  hideModal: () => void;
  name: string;
}

const ReportModal: React.FC<PropTypes> = ({ onClick, hideModal, name }) => {
  const { t } = useTranslation();
  const [stage, setStage] = useState<number>(1);
  const [text, setText] = useState<string>();

  const handleOnClick = () => {
    if (stage === 1) {
      onClick(text);
      setStage(2);
    } else {
      hideModal();
    }
  };

  return (
    <div className="p-12 m-auto text-center">
      {stage === 2 && (
        <span className="material-icons pr-1 text-primary text-5xl align-text-bottom border-4 rounded-full border-black">
          done
        </span>
      )}
      <h2
        className={`pt-8 font-bold text-center ${
          stage === 1 ? 'text-lg' : 'text-2xl'
        }`}
      >
        {t(`chatroom.reportModal${stage}Title`, {
          name,
        })}
      </h2>
      {stage === 1 ? (
        <textarea
          value={text}
          placeholder={t('chatroom.reportModalPlaceholder')}
          className="mt-8 p-4 w-120"
          onChange={(e) => setText(e.target.value)}
          rows={5}
        />
      ) : (
        <p className="pt-4 text-grey-50">{t('chatroom.reportModal2Desc')}</p>
      )}
      <div className="flex justify-center pt-8">
        <Button type="button" variant="primary" onClick={handleOnClick}>
          {t(`chatroom.reportModal${stage}Btn`)}
        </Button>
      </div>
    </div>
  );
};

export default ReportModal;
